module.exports = __webpack_public_path__ + "static/img/sy_t2_3.0f015a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/sy_t2_3.png
// module id = l74/
// module chunks = 16